export function isSitePreviewEnabled() {
    return process.env.SITE_PREVIEW_ENABLED === 'true';
}
